@for (kpiByCategory of kpisByCategory; track $index) {
  <span class="kpis-tbl-header">{{ kpiByCategory.category }}</span>
  <div #tooltipContainer>
    <table mat-table class="mat-table" [dataSource]="getDataSource(kpiByCategory.category)">
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
        <th mat-header-cell *matHeaderCellDef [ngClass]="getColumnClass(column.key)">
          <span>{{ column.label }}</span>
        </th>

        <td mat-cell *matCellDef="let element" [ngClass]="getColumnClass(column.key)">
          <ng-container [ngSwitch]="column.key">
            <status-badge
              *ngSwitchCase="'status'"
              [type]="'kpiHealth'"
              [badgeKey]="element.status"
              [showLabel]="!hideBadgeLabel"
            >
            </status-badge>
            <span *ngSwitchCase="'value'" class="kpis-tbl-value">
              <span class="kpis-tbl-primary-value">{{
                isValid(element.value.displayValue)
                  ? element.value.displayValue + element.value.displayUnit
                  : '–'
              }}</span>
              <span
                >|
                {{
                  isValid(element.value.displaySecondaryValue)
                    ? element.value.displaySecondaryValue
                    : '–'
                }}</span
              >
            </span>

            <span class="kpis-tbl-trend" *ngSwitchCase="'trend'">
              <kpi-trend-indicator
                [trendIndicator]="element.trend.trendIndicator"
                [trendChange]="element.trend.trendChange"
                [kpiType]="element.type"
                [kpiName]="element.name"
                [showPlaceholder]="false"
              >
              </kpi-trend-indicator>
              {{ element.trend.trendText }}
            </span>
            <span *ngSwitchCase="'name'" class="kpis-tbl-overflow-text">{{
              element[column.key]
            }}</span>
          </ng-container>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
      <tr
        data-tooltip-element
        mat-row
        *matRowDef="let row; columns: columnKeys"
        class="kpis-tbl-row"
        [attr.kpis-tbl-row-selected]="row.isSelected"
        (click)="rowClicked(row)"
        (mouseenter)="onRowMouseEnter(row, $event)"
        (mouseleave)="onRowMouseLeave()"
      ></tr>
    </table>

    <cds-tooltip
      *ngIf="hoveredRow && tooltipOriginElement"
      [origin]="tooltipOriginElement"
      [open]="tooltipOpen"
      [tooltipId]="'kpi-table-tooltip-' + hoveredRow.key"
      placement="top"
      [panelWidth]="280"
      [hasBackdrop]="false"
      [enableHoverDelay]="true"
      (hovered)="onTooltipHover()"
      (unhovered)="onTooltipLeave()"
    >
      <ng-template #tooltipContent>
        <div class="kpi-tooltip-header">{{ hoveredRow.name }}</div>
        <div class="kpi-tooltip-content">
          <kpi-tooltip
            [kpiName]="hoveredRow.name"
            [kpiKey]="hoveredRow.key"
            [keyMilestones]="keyMilestones"
          ></kpi-tooltip>
        </div>
      </ng-template>
    </cds-tooltip>
  </div>
}
